/**
 * Formaterar ett notisantal för en badge i navigeringen.
 * Returnerar null när badgen inte ska visas (inget att notifiera om).
 */
export function formatBadgeCount(count: number): string | null {
  if (count <= 0) return null;
  if (count > 9) return '9+';
  return String(count);
}
